export default {
  getTemplate(state) {
    return state.template
  },
}
